import type { Id } from '@goaltree/backend/convex/_generated/dataModel'
import { create } from 'zustand'

// One event detail sheet for the whole app (Today, Upcoming, coach cards,
// reminder deep links), mounted by the authenticated layout.
interface EventSheetState {
  eventId: Id<'nodes'> | null
  open: (eventId: Id<'nodes'>) => void
  close: () => void
}

export const useEventSheet = create<EventSheetState>((set) => ({
  eventId: null,
  open: (eventId) => set({ eventId }),
  close: () => set({ eventId: null }),
}))
